import React, { Component } from 'react';

import cn from 'client/utils/cn';

import './index.css';

const b = cn('title-about');

interface Props {
    title: string;
}

export default class TitleAbout extends Component<Props> {
    render(): React.ReactNode {
        const { title } = this.props;

        return (
            <h2
                className={b()}
                dangerouslySetInnerHTML={{ __html: title }}
                />
        );
    }
}
